export function assertEnum<T extends { [key: string]: string }>(
  enumObj: T,
  value: unknown
): T[keyof T] {
  if (!Object.values(enumObj).includes(value as T[keyof T])) {
    throw new Error(`Invalid enum value: ${value}`);
  }

  return value as T[keyof T];
}
